import React, { useEffect, useState } from "react"
import { Link } from "@tanstack/react-router";
import { TweenMax, Expo } from "gsap/all"
import AccountIcon from "../images/icons/account.svg"
import CustomNavItemMobile from "./Menu/mobile-nav";
import navItems from './Menu/navItems';
import { useMediaQuery } from "react-responsive"

// `logo.logoTitle`/`logo.logoSubtext` are an explicit admin-authored text
// logo — e.g. logoTitle "maasaimara.com" as the brand name and logoSubtext
// "The Definitive Maasai Mara Guide" as the tagline underneath — and take
// priority when set. Otherwise fall back to the site's own domain (e.g.
// "serengetinationalpark.com") — the only other reliable source for the
// header brand text, since `logoName` is an admin field used elsewhere to
// split a name across stacked logo lines and isn't guaranteed to contain
// the full name in its first element.
// Splits a trailing ".tld" (".com", ".info", ...) off so it can be styled
// separately — used for both the admin-authored logoTitle and the
// URL-derived fallback below, so the accent color applies either way.
const splitDomainSuffix = (text) => {
  if (!text) return { main: text || '', suffix: '' };
  const dotIndex = text.lastIndexOf('.');
  if (dotIndex <= 0) return { main: text, suffix: '' };
  return { main: text.slice(0, dotIndex), suffix: text.slice(dotIndex) };
};

const splitBrand = (logo, destinationUrl, destinationName) => {
  const defaultTagline = destinationName ? `The Definitive ${destinationName} Guide` : '';

  if (logo?.logoTitle) {
    const { main, suffix } = splitDomainSuffix(logo.logoTitle);
    return { main, suffix, tagline: logo.logoSubtext || defaultTagline };
  }

  const tagline = defaultTagline;
  let hostname = '';
  try {
    hostname = destinationUrl ? new URL(destinationUrl).hostname.replace('www.', '') : '';
  } catch {
    hostname = '';
  }
  const [name, ...rest] = hostname ? hostname.split('.') : [];
  const capitalizedName = name ? name.charAt(0).toUpperCase() + name.slice(1) : (destinationName || '');
  const main = capitalizedName;
  const suffix = rest.length ? `.${rest.join('.')}` : '';
  return { main, suffix, tagline };
};

const ToolBar = (props) => {
  const { main, suffix, tagline } = splitBrand(props.logo, props.destinationUrl, props.destinationName);
  const [isMounted, setIsMounted] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" })

  useEffect(() => {
    setIsMounted(true);
  }, []);

  let logoContainer = null;
  let hamburger = null;
  let sidemove = null;
  let sidemoveside = null;
  let menu_mobile = null;

  const [listitems, setList] = useState({})
  const [estado, setEstado] = useState(0)

  useEffect(() => {
    setList(document.querySelectorAll("mobile-menu-ul"))
  }, [])

  const hamburgerTween = () => {
    hamburger.classList.toggle("open")


    let delay_time = 0

    if (estado === 0) {
      TweenMax.to(logoContainer, .5, {
        x: "-.500%",
        ease: Expo.easeInOut,
      })
      TweenMax.to(menu_mobile, .5, {
        display: "block",
        ease: Expo.easeInOut,
      })
      TweenMax.to(sidemove, .5, {
        left: "0",
        ease: Expo.easeInOut,
        delay: 0.1,
      })
      TweenMax.to(sidemoveside, .5, {
        left: "0",
        ease: Expo.easeInOut,
        delay: 0.1,
      })

      listitems.forEach(function () {
        TweenMax.to(listitems, .5, {
          x: "-100%",
          delay: 0,
          ease: Expo.easeInOut,
        })
        delay_time += 0
      })
      setEstado(1)
    } else {
      setEstado(0)
      TweenMax.to(menu_mobile, .5, {
        display: "none",
        ease: Expo.easeInOut,
        delay: .1,
      })
      TweenMax.to(sidemove, .5, {
        left: "100%",
        ease: Expo.easeInOut,
      })
      TweenMax.to(sidemoveside, .5, {
        left: "100%",
        ease: Expo.easeInOut,
      })
      TweenMax.to(logoContainer, .5, {
        x: 0,
        ease: Expo.easeInOut,
      })
      listitems.forEach(function () {
        TweenMax.to(listitems, .5, {
          x: 0,
          display: "none",
          delay: 0,
          ease: Expo.easeInOut,
        })
        delay_time += 0
      })
    }
  }

  return (
    <div className="toolbar__container">
      <div className="toolbar__container-left">
        <div className="toolbar__left"></div>
        <div className="header__logo-section">
          <Link to="/" className="header__brand">
            <div className="header__brand-name">
              {main}<span className="header__brand-dotcom">{suffix}</span>
            </div>
            {tagline && <div className="header__brand-sub">{tagline}</div>}
          </Link>
        </div>
      </div>
      <div className="toolbar__container-right">
        <div className="toolbar__top-brand"></div>
        {isMounted && isTabletOrMobile && (
          <div
            id="menu_mobile"
            ref={div => (menu_mobile = div)}
            style={{ display: `none` }}
          >
            <div id="bg-menu-mobile" ref={div => (logoContainer = div)}>
              <div className="bg-menu-mobile__mobile-section-wrapper">
                <div className="bg-menu-mobile__mobile-section-wrapper"></div>
                <div className="bg-menu-mobile__mobile-section-wrapper"></div>
              </div>
            </div>
            <div className="bg-menu-mobile__mobile-section-wrapper" onClick={e => hamburgerTween()}>
              <div className="bg-menu-mobile__mobile-section-menu-items">
                <ul className="mobile-menu-ul" ref={div => (sidemove = div)}>
                  {navItems.map((item, idx) => (
                    <CustomNavItemMobile key={idx} item={item} />
                  ))}
                </ul>
                <ul
                  className="mobile-menu-u-2"
                  ref={div => (sidemoveside = div)}
                >
                  {/* <li className="mobile-menu-item">
                    <img src={searchIcon} />
                  </li> */}
                  <li className="mobile-menu-item">
                    <a
                      href={`/`}
                      target="__blank"
                    >
                      <img src={AccountIcon} />
                    </a>
                  </li>
                  {/* <li className="mobile-menu-item">
                    <img src={facebookIcon} />
                  </li>
                  <li className="mobile-menu-item">
                    <img src={twitterIcon} />
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        )}

        <div className="toolbar__right">
          <div
            id="hamburger"
            ref={div => (hamburger = div)}
            onClick={e => hamburgerTween()}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ToolBar
